import React from 'react';
import './ValidationErrorDisplay.css';

interface ValidationError {
  field: string;
  message: string;
  value?: any;
}

interface ValidationErrorDisplayProps {
  errors: ValidationError[];
  onDismiss: () => void;
}

const ValidationErrorDisplay: React.FC<ValidationErrorDisplayProps> = ({ errors, onDismiss }) => {
  if (!errors || errors.length === 0) {
    return null;
  }

  // Map field names to user-friendly labels
  const fieldLabels: Record<string, string> = {
    recipientCompany: 'Recipient Company Name',
    recipientBank: 'Recipient Bank Name',
    recipientBankSwiftCode: 'SWIFT Code',
    accountNumber: 'Account Number',
    recipientBankCountry: 'Recipient Bank Country',
    recipientAddress: 'Recipient Address',
    recipientBankAddress: 'Bank Address',
    foreignAmount: 'Foreign Amount',
    foreignCurrency: 'Foreign Currency',
    localAmount: 'Local Amount',
    exchangeRate: 'Exchange Rate',
    invoiceS3Key: 'Invoice File',
    invoiceFileName: 'Invoice File Name',
    invoiceFileSize: 'Invoice File Size',
    invoiceMimeType: 'Invoice File Type',
  };

  return (
    <div className="validation-error-overlay">
      <div className="validation-error-modal">
        <div className="error-modal-header">
          <div className="error-icon">⚠️</div>
          <h3>Validation Errors</h3>
          <button className="error-close-btn" onClick={onDismiss}>
            ×
          </button>
        </div>

        <div className="error-modal-body">
          <p className="error-intro">
            Please correct the following errors before submitting:
          </p>

          <div className="error-list">
            {errors.map((error, index) => (
              <div key={index} className="error-item">
                <div className="error-field">
                  {fieldLabels[error.field] || error.field}
                </div>
                <div className="error-message">
                  {error.message}
                </div>
              </div>
            ))}
          </div>

          <div className="error-tips">
            <h4>💡 Tips:</h4>
            <ul>
              <li>Check that all required fields are filled</li>
              <li>Ensure amounts are positive numbers</li>
              <li>SWIFT codes should be 8-11 characters (e.g., ABCDEFGH or ABCDGH2AXXX)</li>
              <li>Invoice must be a PDF, JPG, PNG, or JPEG file (max 10MB)</li>
              <li>All addresses must be at least 10 characters long</li>
            </ul>
          </div>
        </div>

        <div className="error-modal-footer">
          <button className="error-modal-ok-btn" onClick={onDismiss}>
            Got It, Let Me Fix These
          </button>
        </div>
      </div>
    </div>
  );
};

export default ValidationErrorDisplay;
